import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initTracking, trackPageView } from "@/utils/tracking";

export const useTracking = () => {
  const location = useLocation();
  useEffect(() => { initTracking(); }, []);
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};
